/**
 * Real product screenshots only — no placeholders, no mock UI, no stock photography.
 * Images are CDN asset pointers created from screenshots of the running app.
 */
import quickLog from '@/assets/IMG_0740.png.asset.json';
import sauces from '@/assets/IMG_0744.png.asset.json';
import deviation from '@/assets/IMG_0746.png.asset.json';
import signature from '@/assets/IMG_0741.png.asset.json';

type Shot = { src: string; alt: string; caption: string };

const shots: Shot[] = [
  {
    src: quickLog.url,
    alt: 'Quick Log screen listing fridge and hot-hold temperatures, with two readings flagged red for being outside their allowed range',
    caption:
      'Log a round of temps in under a minute. Anything outside its range flags itself immediately.',
  },
  {
    src: sauces.url,
    alt: 'Sauces tab showing a cold sauce check part-way through, with 4 of 11 sauces recorded and a progress bar',
    caption:
      'Progress is visible per check, so a half-finished round is obvious at handover.',
  },
  {
    src: deviation.url,
    alt: 'Deviation Details panel showing an out-of-range Bearnaise reading with a timestamp and a list of corrective actions to choose from',
    caption:
      'Every out-of-range reading becomes a deviation with a timestamp and a corrective action — the record an inspector asks for.',
  },
  {
    src: signature.url,
    alt: 'Sign Here dialog with a full name field and a drawn signature on a touch signature pad',
    caption: 'Name and signature captured on the device. No paper, no back-dating.',
  },
];

const ProductShots = () => {
  if (shots.length === 0) return null;

  return (
    <section id="screens" className="relative">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        <h2 className="heading-section text-white mb-4 text-center">
          See it before you commit
        </h2>
        <p className="text-white/70 text-center max-w-2xl mx-auto mb-10">
          Actual screens, taken from the running app. Available now on iPhone, iPad and Android.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {shots.map((shot) => (
            <figure key={shot.src} className="flex flex-col">
              <div className="rounded-[2rem] border border-white/15 bg-black/40 p-2 shadow-2xl">
                <img
                  src={shot.src}
                  alt={shot.alt}
                  width={883}
                  height={1920}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto rounded-[1.6rem]"
                />
              </div>
              <figcaption className="pt-4 text-white/70 text-sm leading-relaxed">
                {shot.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShots;